import { render, staticRenderFns } from "./SplashTexts.vue?vue&type=template&id=0e5a39a1"
import script from "./SplashTexts.vue?vue&type=script&lang=ts"
export * from "./SplashTexts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports